import AuthService from "@/services/auth.service";
import { store } from "@/store";
import { ActionTypes } from "@/store/actions";
import { RouteRecordRaw } from "vue-router";
import Hall from "@/views/izi/hall/Hall.vue";
import RoomList from "@/views/izi/roomList/RoomList.vue";
import { ScreenType } from "@/enum/screen.type";
import CreateChallenge from "@/views/izi/createChallenge/CreateChallenge.vue";
import SetupChallenge from "@/views/izi/setupChallenge/SetupChallenge.vue";
import Profile from "@/views/izi/profile/Profile.vue";
export const iziRouter: RouteRecordRaw[] = [
  {
    path: "/index",
    name: "index",
    component: () =>
      import(/* webpackChunkName: "index" */ "../views/izi/main/main.vue"),
    beforeEnter: (to, from, next) => {
      AuthService.getCurrentAuth().subscribe(result => {
        if (result) {
          store.dispatch(ActionTypes.SET_CURRENT_USER, result);
          next(true);
        } else {
          next("/login");
        }
      });
    },
    children: [
      {
        path: "/",
        redirect: ScreenType.hall
      },
      {
        path: "/profile",
        name: ScreenType.profile,
        component: Profile
      },
      {
        path: "/hall",
        name: ScreenType.hall,
        component: Hall
      },
      {
        path: "/hall/roomlist/:gameId",
        name: ScreenType.roomlist,
        component: RoomList
      },
      {
        path: "/setup",
        name: ScreenType.setupChallenge,
        component: SetupChallenge,
        beforeEnter: (to, from, next) => {
          store.dispatch(ActionTypes.GET_CHALLENGES_SETTINGS, undefined);
          next(true);
        }
      },
      {
        path: "/create-challenge",
        name: ScreenType.createChallenge,
        component: CreateChallenge,
        beforeEnter: (to, from, next) => {
          const { settings } = store.getters.getChallengeSettingSelected;
          if (settings.length > 0) {
            next(true);
          }
          next("/setup");
        }
      }
    ]
  },
  {
    path: "/",
    redirect: "index"
  }
];
